import WebAPI from './WebAPI'
import CON from '../appLogic/notifications/notificationConstants'

const API_ROOT_OPEN_AP = process.env.API_ROOT_OPEN_AP

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/325156865/Notifications
 */
class NotificationAPI extends WebAPI {
  constructor () {
    super({baseURL: API_ROOT_OPEN_AP})
    this.CON = CON
  }

  /**
   */
  getNotifications ({notification_type, user_id, target_id, status} = {}) {
    return this.__post({
      payload: {notification_type, user_id, target_id, status},
      extensionURL: '/Audience/GetNotifications',
      addSession: true
    }).catch(error => {
      console.log(error)
      return []
    })
  }

  /**
   * Creates a new Notification, do not use this to update a notification
   * id, status, description, notification_type, alert_level, user_id, target_id, broadcast_type
   */
  saveNotifications (notification) {
    return this.__post({payload: notification, extensionURL: '/Audience/SaveNotification', addSession: true})
  }

  /**
   * Updates the notification
   */
  updateNotification ({notification_id, user_id, status}) {
    if (!user_id) {
      throw new Error('to update a Notification, you must provide the User_id')
    }
    return this.__post({
      payload: JSON.stringify({
        notification_id,
        user_id,
        status
      }),
      extensionURL: '/Audience/UpdateNotificationStatus',
      addSession: true
    })
  }
  // `The Open AP target, ${targetName}, has been saved in Audience Matters.`,
  deleteNotification (notification) {
    let updateNotification = {
      notification_id: notification.id,
      status: CON.STATUS_DELETED,
      user_id: notification.user_id
    }
    return this.updateNotification(updateNotification)
  }
}

export default new NotificationAPI()



// WEBPACK FOOTER //
// ./src/app/api/NotificationAPI.js